import type {
  DefaultProps,
  NinjaToasterBaseProps,
} from '@cssninja/nuxt-toaster'
import type { TairoToaster } from '#components'

// This type infer the props of TairoToaster component
type TairoToasterProps = Omit<
  InstanceType<typeof TairoToaster>['$props'],
  keyof DefaultProps
>

export function useToaster() {
  const $nt = useNinjaToaster()

  /**
   * Display a TairoToaster component
   */
  function show(props: TairoToasterProps, options?: NinjaToasterBaseProps) {
    options = options || {
      duration: props.message?.length ? (props.message.length > 60 ? 8000 : 4000) : 4000,
      theme: {
        maxToasts: 1,
        containerId: 'bottom-center',
        containerClass: [
          'fixed',
          'inset-0',
          'pointer-events-none',
          'p-4',
          'flex',
          'flex-col-reverse', // bottom
          'overflow-hidden',
          'z-[999999]',
          'items-center', // center
          'gap-2',
          'space-y-3',
        ],
        wrapperClass: [
          'pointer-events-auto',
          'focus:outline-none',
          'rounded',
          'outline-slate-300',
          'outline-offset-2',
          'focus:outline',
          'focus:outline-2',
          'focus-within:outline',
          'focus-within:outline-2',
        ],
        transition: {
          enterActiveClass: 'transition duration-300 ease-out',
          enterFromClass: 'transform translate-y-full opacity-0',
          enterToClass: 'transform translate-y-0 opacity-100',
          leaveActiveClass: 'transition duration-200 ease-in',
          leaveFromClass: 'transform translate-y-0 opacity-100',
          leaveToClass: 'transform translate-y-full opacity-0',
        },
      },
      pauseOnHover: true,
      dismissible: true,
    }

    return $nt.showComponent('TairoToaster', {
      props,
      options,
    })
  }

  return {
    show,
    clear: $nt.clear,
    clearAll: $nt.clearAll,
  }
}
